import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import IconEffect1 from "../icons/effect1";

import { loadTickers } from "../../redux/actions/tickers";
import { getTickers } from "../../redux/selectors/tickers";

class Marquee extends Component {
    componentDidMount() {
        this.props.loadTickers();
    }

    _renderLastTitles() {
        const { color, tickers } = this.props;

        return (
            <div className="flex items-center h-60 xl:h-70">
                {tickers.map((ticker) => {
                    if (ticker.url) {
                        return (
                            <div key={ticker.id} className="flex items-center">
                                <IconEffect1
                                    className={
                                        "inline-block w-20 xl:w-25 h-20 xl:h-25 mx-20 xl:mx-30 text-" +
                                        color
                                    }
                                />
                                <Link
                                    to={ticker.url}
                                    className={
                                        "inline-block font-bold text-20 xl:text-26 text-" +
                                        color
                                    }
                                    title={ticker.name}
                                >
                                    {ticker.name}
                                </Link>
                            </div>
                        );
                    } else {
                        return (
                            <div key={ticker.id} className="flex items-center">
                                <IconEffect1
                                    className={
                                        "inline-block w-20 xl:w-25 h-20 xl:h-25 mx-20 xl:mx-30 text-" +
                                        color
                                    }
                                />
                                <p
                                    className={
                                        "inline-block font-bold text-20 xl:text-26 text-" +
                                        color
                                    }
                                >
                                    {ticker.name}
                                </p>
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    render() {
        const { backgroundColor, tickers } = this.props;

        const shouldAnimate = true;

        let baseName = "w-full overflow-hidden";
        let className = "inline-flex";
        let className2 = "inline-flex";

        if (shouldAnimate) {
            className += " marquee";
            className2 += " marquee";
        }

        if (backgroundColor) {
            baseName += " " + backgroundColor;
        }

        if (!tickers || tickers.length === 0) return null;

        return (
            <div className={baseName}>
                <div className="marquee-wrapper whitespace-nowrap overflow-hidden mx-auto">
                    <div className={className}>{this._renderLastTitles()}</div>
                    {shouldAnimate && (
                        <div className={className2}>
                            {this._renderLastTitles()}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Marquee.defaultProps = {
    color: "blue",
    backgroundColor: null,
};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    tickers: getTickers(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadTickers,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Marquee);
